var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_edit_3139618") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Games/Questions-options",
    transform: "translate(-1100.000000, -408.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(50.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown-Options",
    transform: "translate(687.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_edit_3139618",
    transform: "translate(23.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.806011)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "12.9095355 4.13414634 10.8924205 2.12195122 3.99755501 9 3.44743276 11.5609756 6.01466993 11.0121951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.405868,1.6097561 L13.4229829,3.62195122 L14.9266504,2.12195122 C15,2.01219512 15,1.86585366 14.9266504,1.79268293 L13.2396088,0.109756098 C13.1662592,0 12.9828851,0 12.9095355,0.109756098 L11.405868,1.6097561 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4327628,6.18292683 C12.4327628,5.85365854 12.6894866,5.56097561 13.0562347,5.56097561 C13.3863081,5.56097561 13.6797066,5.85365854 13.6797066,6.18292683 L13.6797066,12.8414634 C13.6797066,14.0487805 12.6894866,15 11.4792176,15 L2.16381418,15 C0.990220049,15 0,14.0487805 0,12.8414634 L0,3.54878049 C0,2.37804878 0.990220049,1.3902439 2.16381418,1.3902439 L8.80195599,1.3902439 C9.13202934,1.3902439 9.42542787,1.64634146 9.42542787,2.01219512 C9.42542787,2.34146341 9.13202934,2.63414634 8.80195599,2.63414634 L2.16381418,2.63414634 C1.65036675,2.63414634 1.24694377,3.03658537 1.24694377,3.54878049 L1.24694377,12.8414634 C1.24694377,13.3536585 1.65036675,13.7926829 2.16381418,13.7926829 L11.4792176,13.7926829 C11.992665,13.7926829 12.4327628,13.3536585 12.4327628,12.8414634 L12.4327628,6.18292683 Z",
    id: "Path"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenNew);
export default __webpack_public_path__ + "static/media/pen-new.b725cb9edb08c9e94eaace511dc7d81d.svg";
export { ForwardRef as ReactComponent };